import { render, staticRenderFns } from "./DataTableCurrencyColumn.vue?vue&type=template&id=6f316dd8&"
import script from "./DataTableCurrencyColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableCurrencyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports